import { useMutation } from '@northladder/services';

import { BIDS_API } from '../bidsAPIClient';

/**
 * This is to track the upload bid file status mutation keys in react query cache.
 */
const MUT_UPLOAD_BID_FILE = 'upload-bid-file-mutation-key';

/**
 * This performs a post request for uploading the bid file by category.
 */
export const useUploadBidFileMutation = () => {
  const { data, isPending, isError, error, mutate, reset, isSuccess } =
    useMutation({
      mutationKey: [MUT_UPLOAD_BID_FILE],
      networkMode: 'always', // Even make calls when offline
      mutationFn: BIDS_API.uploadBidFile,
    });

  return {
    data,
    error,
    isError,
    isPending,
    isSuccess,
    mutate,
    reset,
  };
};
